import React, { useContext, useState, useEffect } from 'react';
import { SearchBox } from '@monash/portal-react';
import { SearchContext } from '../../providers/search-provider/SearchProvider';
import { getIcon } from '@monash/portal-frontend-common';
import c from './search-bar.module.scss';

const SearchBar = () => {
  const {
    searchTarget,
    runSearch,
    runSearchSuggestions,
    searchSuggestionsResult,
  } = useContext(SearchContext);

  const [searchString, setSearchString] = useState(searchTarget);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search).get('query');
    if (query) {
      runSearch(query, false);
    }
  }, []);

  useEffect(() => {
    runSearchSuggestions(searchString.trim());
  }, [runSearchSuggestions, searchString]);

  useEffect(() => {
    setSearchString(searchTarget);
  }, [searchTarget]);

  const quickLinks = searchSuggestionsResult?.quickLinks?.map((link) => ({
    ...link,
    icon: link.app ? getIcon(link.app, 20) : getIcon(link.icon, 20),
  }));

  const links = searchSuggestionsResult?.links?.map((link) => ({
    ...link,
    icon: link.app ? getIcon(link.app, 20) : getIcon(link.icon, 20),
  }));

  return (
    <div className={c.searchBar}>
      <SearchBox
        searchString={searchString}
        onInput={setSearchString}
        onSearch={runSearch}
        quickLinks={quickLinks}
        historySearches={searchSuggestionsResult?.searchHistory}
        links={links}
      />
    </div>
  );
};

export default SearchBar;
